import {
  VolleyballCardsAttribute,
  VolleyballIncidentId,
} from '@collector/sportsapi-client-legacy'

import { IncidentsResultConfig } from '../../configuration'

export const incidentsResultConfig: IncidentsResultConfig<VolleyballIncidentId> =
  {
    scoringIncidents: new Map([
      [VolleyballIncidentId.ServiceAce, { add: 1, visible: true }],
      [VolleyballIncidentId.AttackPoint, { add: 1, visible: true }],
      [VolleyballIncidentId.BlockPoint, { add: 1, visible: true }],
      [VolleyballIncidentId.Point, { add: 1, visible: true }],
      [VolleyballIncidentId.SecondSetStarted, { set: 0 }],
      [VolleyballIncidentId.ThirdSetStarted, { set: 0 }],
      [VolleyballIncidentId.FourthSetStarted, { set: 0 }],
      [VolleyballIncidentId.FifthSetStarted, { set: 0 }],
    ]),
    oppositeTeamScoringIncidents: new Map([
      [VolleyballIncidentId.ServiceError, { add: 1, visible: true }],
      [VolleyballIncidentId.AttackError, { add: 1, visible: true }],
      [VolleyballIncidentId.TechnicalErrors, { add: 1, visible: true }],
      [VolleyballIncidentId.SecondSetStarted, { set: 0 }],
      [VolleyballIncidentId.ThirdSetStarted, { set: 0 }],
      [VolleyballIncidentId.FourthSetStarted, { set: 0 }],
      [VolleyballIncidentId.FifthSetStarted, { set: 0 }],
      [
        VolleyballIncidentId.Cards,
        {
          attributes: new Map([
            [VolleyballCardsAttribute.RedCard, { add: 1, visible: true }],
          ]),
        },
      ],
    ]),
  }
